import{validateUuid as t,generateGUID as r}from"./utils.js";class i{constructor(i=r()){this.uuid=i,t(i)}toString(){return this.uuid}}export{i as UUID};
